import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import 'rxjs/add/operator/map'
import { SampleSearchFields } from '../../../common/viewModels/Analysis/SampleModel';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';
import { FormatService } from '../../../common/formatService';
import { JobCardDDLModel, SampleStatusDDLModel, SampleModel } from '../../../common/viewModels/Analysis/SampleModel';
import { SpIdSearchFields } from '../../../common/viewModels/GlobalRegistry/SampPointModel';
declare var $: any;

@Component({
    selector: 'publishresults',
    templateUrl: './publishresults.component.html',
    styleUrls: ['./publishresults.component.scss']
})
export class PulishResultsListComponent implements OnInit {
    publishSearchForm: FormGroup;
    searchFields: SampleSearchFields = new SampleSearchFields();
    id: number;
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    customers: CustomerModel[];
    lstJobCards: JobCardDDLModel[];
    lstSampleStatus: SampleStatusDDLModel[];
    lstSpIds: SpIdSearchFields[];
    sampleDto: SampleModel;
    isShow: boolean = false;
    isShowbtnDownload: boolean = false;
    lstSampleTypes: any[];
    labs: any;
    pageSize: number = 10;
    isShowSelectOption: boolean = true;

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _formatService: FormatService) {
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.createSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.publishSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId) {
            this.publishSearchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
            this.isShowSelectOption = false;
            this.BindSpId(this.publishSearchForm.get('CustomerId').value);
        }

        //this.GetJobCradsForDDL();
        //this.GetSampleStatusForDDL();
        this.BindStaticSearchData();
        this.setPage(this.pager);
        this.GetCustomers();
        this.GetLabs();
        this.GetSampleStatusForDDL();
        this.GetSampleTypes();
    }

    createSearchForm() {
        this.publishSearchForm = this._formBuilder.group({
            CustomerId: [''],
            SampleNo: [''],
            LabIds: [''],
            SpId: [''],
            JobCardNumber: [''],
            PublishedDateFrom: [null],
            PublishedDateTo: [null],
            SampleTypeId: ['']
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetPublishResults(this.pager);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._mApp.pageSize;
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetJobCradsForDDL() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetJobcradsForDDL)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this.lstJobCards = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                    if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetSampleStatusForDDL() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetSampleStatusForDDL)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this.lstSampleStatus = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetPublishResults(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetPublishedResults, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSubmit() {
        this.pager.pageIndex = 0;
        let searchDto = this.publishSearchForm.value;
        this.searchFields.SpId = searchDto.SpId;
        this.searchFields.JobCardNumber = searchDto.JobCardNumber;
        this.searchFields.LabIds = searchDto.LabIds;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.SampleTypeId = searchDto.SampleTypeId;
        this.searchFields.PublishedDateFrom = this._formatService.formatDate(searchDto.PublishedDateFrom);
        this.searchFields.PublishedDateTo = this._formatService.formatDate(searchDto.PublishedDateTo);

        this.setPage(this.pager);
    }

    OnReset() {
        this.publishSearchForm.reset();
        this.searchFields.SampleNo = "";
        this.searchFields.SpId = 0;
         this.searchFields.LabIds = [];
        this.searchFields.JobCardNumber = "";
        this.searchFields.PublishedDateFrom = '';
        this.searchFields.PublishedDateTo = '';
        this.searchFields.CustomerId = this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0;
        this.BindSpId(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
        this.searchFields.SampleTypeId = 0;
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        // this.publishSearchForm.controls['LabIds'].setValue(this._mApp.currentUserLabIds ? this._mApp.currentUserLabIds : []);
        this.publishSearchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
        this.GetCustomers();
        this.lstSpIds = null;
        this.setPage(this.pager);
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        if (this._mApp.userTypeId == 2) {
            this.publishSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3) {
            this.BindSpId(this.publishSearchForm.get('CustomerId').value);
        }
    }

    DownloadFile(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetSampleReportById + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var data = res.json().Result;
                    this._mApp.DownloadFile(data);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    ViewReport(sampleId: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DownLoadSampleReport + sampleId + "&viewReport=" + true)
            .subscribe(
                res => {

                    this._mApp.HideLoader();
                    $("#dvAttchHtml").append(res.json().Result);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    RemoveHtmlFromDiv() {
        $("#dvAttchHtml").html("");
    }


    BindSpId(custId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.PopulateSpIdValuesByCustomerId + custId)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstSpIds = data.json().Result;
                    }
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetSampleTypes() {
        this._http.get(this._appUrl.GetMinInfoSampleTypes)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstSampleTypes = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }
}
